import { render } from "./ActivationView.vue?vue&type=template&id=4e863ab7"
import script from "./ActivationView.vue?vue&type=script&lang=js"
export * from "./ActivationView.vue?vue&type=script&lang=js"

import exportComponent from "G:\\deploy\\cfan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__